import { ResponseError } from '@backstage/errors';

class PlaylistClient {
  discoveryApi;
  fetchApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getAllPlaylists(req = {}) {
    const { filter = [], editable } = req;
    const params = [];
    for (const filterItem of [filter].flat()) {
      const filterParts = [];
      for (const [key, value] of Object.entries(filterItem)) {
        for (const v of [value].flat()) {
          if (typeof v === "string") {
            filterParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
            );
          }
        }
      }
      if (filterParts.length) {
        params.push(`filter=${filterParts.join(",")}`);
      }
    }
    if (editable) {
      params.push("editable=true");
    }
    const query = params.length ? `?${params.join("&")}` : "";
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(`${baseUrl}/${query}`, {
      method: "GET"
    });
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    return await resp.json();
  }
  async createPlaylist(playlist) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(`${baseUrl}/`, {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(playlist)
    });
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    return await resp.json();
  }
  async getPlaylist(playlistId) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(`${baseUrl}/${playlistId}`, {
      method: "GET"
    });
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    return await resp.json();
  }
  async updatePlaylist(playlist) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(`${baseUrl}/${playlist.id}`, {
      headers: { "Content-Type": "application/json" },
      method: "PUT",
      body: JSON.stringify(playlist)
    });
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
  async deletePlaylist(playlistId) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(`${baseUrl}/${playlistId}`, {
      method: "DELETE"
    });
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
  async addPlaylistEntities(playlistId, entityRefs) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${playlistId}/entities`,
      {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(entityRefs)
      }
    );
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
  async getPlaylistEntities(playlistId) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${playlistId}/entities`,
      { method: "GET" }
    );
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    return await resp.json();
  }
  async removePlaylistEntities(playlistId, entityRefs) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${playlistId}/entities`,
      {
        headers: { "Content-Type": "application/json" },
        method: "DELETE",
        body: JSON.stringify(entityRefs)
      }
    );
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
  async followPlaylist(playlistId) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${playlistId}/followers`,
      { method: "POST" }
    );
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
  async unfollowPlaylist(playlistId) {
    const baseUrl = await this.discoveryApi.getBaseUrl("playlist");
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${playlistId}/followers`,
      { method: "DELETE" }
    );
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
  }
}

export { PlaylistClient };
//# sourceMappingURL=PlaylistClient.esm.js.map
